var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-centered-column',[_c('zmanim-navigation'),_c('app-jumbotron',[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('app-jumbotron-banner')],1)]),_c('div')],1),_c('zmanim-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }